import {ProductBarcode} from "./productBarcode";
import {Company} from "../company";
import {User} from "../user";
import {Order} from "./order";

export class OrderAddress {

    id?: string;
    email: string = '';
    firstName: string = '';
    lastName: string = '';
    address: string = '';
    addressOptional?: string;
    zip: string = '';
    province: string = '';
    city: string = '';
    legalFirstName?: string;
    legalLastName?: string;
    legalAddress?: string;
    legalAddressOptional?: string;
    legalZip?: string;
    legalProvince?: string;
    legalCity?: string;
    status!: string;
    orders?: Order[];
    businessName?: string;
    vat?: string;
    pec?: string;
    sdi?: string;

    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.email = raw.email;
            this.firstName = raw.firstName;
            this.lastName = raw.lastName;
            this.address = raw.address;
            this.addressOptional = raw.addressOptional;
            this.zip = raw.zip;
            this.province = raw.province;
            this.city = raw.city;
            this.legalFirstName = raw.legalFirstName;
            this.legalLastName = raw.legalLastName;
            this.legalAddress = raw.legalAddress;
            this.legalAddressOptional = raw.legalAddressOptional;
            this.legalZip = raw.legalZip;
            this.legalProvince = raw.legalProvince;
            this.legalCity = raw.legalCity;
            this.businessName = raw.businessName;
            this.vat = raw.vat;
            this.pec = raw.pec;
            this.sdi = raw.sdi;
            this.status = raw.status;
            if (raw.orders && raw.orders.length > 0) this.orders = raw.orders;
        }
    }
}
